import mAxios from './m-axios'

export interface Question {
  id: number
  paper_id: number // 试卷ID
  type: number //1:单选,2:多选,3:判断,4:问答,5:操作
  sort: number // 题号
  score: number // 分值
  ai_score: number // AI概念
  calc_score: number // 计算思维
  inte_score: number //智能意识
  inno_score: number // 探究创新
  soc_score: number // 智能社会责任
  image?: string // 配图
  desc: string
  a: string
  b: string
  c: string
  d: string
  answer: string
  explain?: string
  key?: number
  hasAnswer?: boolean
  myAnswer?: number[]
  showType?: boolean
}
export const listQuestion = (paper_id: number) => {
  return mAxios({
    method: 'get',
    url: '/api/question',
    params: {
      paper_id: paper_id,
    },
  }).then(res => res.data)
}
